var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"funds-custom-row"},[_c('td',{attrs:{"tabindex":"0","colspan":"3"}},[_vm._v("123")]),_c('td',{attrs:{"tabindex":"0","colspan":"3"}},[_vm._v("444")])])
}]

export { render, staticRenderFns }